<template>
  <div>
    <input type="checkbox" :checked="confirm.visible" class="modal-toggle">
    <div class="modal">
      <div class="modal-box">
        <h3 class="font-bold text-lg">{{ confirm.title || 'Баталгаажуулах асуулт' }}</h3>
        <div class="py-5" >
          <p v-if="confirm.message">{{ confirm.message }}</p>
          <div v-if="confirm.currency">
            <my-input v-model="value" label="Мөнгөн дүн" currency></my-input>
            <my-select v-model="cancelType" label="Цуцлах шалтгаан" v-if="confirm.isCancelType" :options="cancelTypes" />
            <my-select v-model="cashe" label="Төлсөн хэлбэр" v-if="confirm.isCashe" :options="paymentCashes" />
            <my-input label="Төлсөн огноо" v-model="paidAt" v-if="confirm.isCashe" mask="####-##-##" placeholder="ЖЖЖЖ-СС-ӨӨ"></my-input>
            <my-input v-model="note" label="Тайлбар"></my-input>
          </div>
        </div>
        <div class="modal-action space-x-4 mt-0">
          <my-button type="primary" @click="handleYes" icon="check">{{ confirm.btnTextYes || 'Тийм' }}</my-button>
          <my-button @click="confirm_no" icon="x">{{ confirm.btnTextNo || 'Үгүй' }}</my-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      value: 0,
      note: '',
      cancelType: null,
      cashe: { id: 1 },
      paidAt: '',
      paymentCashes: [],
      cancelTypes: []
    }
  },
  computed: {
    ...mapGetters(['confirm'])
  },
  watch: {
    'confirm.visible' (val) {
      this.value = 0
      this.note = ''
      this.cancelType = null
      this.cashe = { id: 1 }
      this.paidAt = this.moment().format('YYYY-MM-DD')
      if (val && this.confirm.isCancelType) {
        this.getCancelTypes()
      }
      if (val && this.confirm.isCashe) {
        this.getPaymentCashes()
      }
    }
  },
  methods: {
    ...mapActions(['confirm_yes', 'confirm_no']),
    getCancelTypes () {
      this.axios.get('lookups/cancel_types').then(c => {
        this.cancelTypes = c.data
      }).catch(this.handleError)
    },
    getPaymentCashes () {
      this.axios.get('lookups/payment_cashes').then(c => {
        this.paymentCashes = c.data
      }).catch(this.handleError)
    },
    handleYes () {
      try {
        if (this.confirm.currency) {
          if (this.value <= 0) {
            this.customError('Мөнгөн дүн оруулна уу!.')
          }
        }
        if (this.confirm.isCashe) {
          if (!this.cashe) {
            this.customError('Төлсөн хэлбэр сонгоно уу!.')
          }
          console.log('this.paidAt', this.paidAt)
          if (!this.moment(this.paidAt, 'YYYY-MM-DD', true).isValid()) {
            this.customError('Төлсөн огноо буруу байна!.')
          }
        }
        this.confirm_yes({
          value: this.value,
          note: this.note,
          cancelType: this.cancelType,
          cashe: this.cashe,
          paidAt: this.paidAt
        })
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
